import { Property } from "@/interfaces/property.interface";
import {
  getPlaceholdJPUrl,
  getTextColorForBackground,
  isColorWhite,
} from "@/lib/agency-gradient";
import clsx from "clsx";
import Image from "next/image";

export interface CardHeaderHeaderProps {
  property: Property;
  index: number;
}

export const CardHeader = (props: CardHeaderHeaderProps) => {
  const { property, index } = props;

  return (
    <div
      className={clsx(
        "flex h-8 w-full items-center justify-between py-0.5 px-2",
        {
          "border-b": isColorWhite(property.agency.color!),
        }
      )}
      style={{
        background: property.agency.color,
      }}
    >
      <div className="relative h-full w-28 ml-2">
        <Image
          fill
          src={
            property.agency?.logo ??
            getPlaceholdJPUrl(
              property.agency.name,
              property.agency.color,
              getTextColorForBackground(property.agency.color ?? "000"),
              100,
              "1000x100"
            )
          }
          className="rounded-md object-contain transition-transform duration-300 hover:scale-105"
          alt={property.agency?.name}
          quality={100}
          priority={index === 0 ? true : false}
          fetchPriority={index === 0 ? "high" : "low"}
          sizes="(max-width: 768px) 20vw, 5vw"
        />
      </div>
    </div>
  );
};
